import { TState } from '@/types';

export const defaultStoreState: TState = {};
